<template>
  <section class="form-list">
    <el-form
      class="form form-large"
      ref="form"
      :rules="rules"
      :model="courseVideo"
      label-position="right"
      label-width="130px"
    >
      <el-form-item label="视频名称" prop="course_video_name">
        <el-input
          v-model="courseVideo.course_video_name"
          maxlength="14"
          show-word-limit
          clearable
          placeholder="请输入视频名称"
        />
      </el-form-item>

      <v-image-upload
        v-model="courseVideo.cover"
        label="视频封面"
        prefix="course-video-cover"
        ratio="16:9"
        prop-name="cover"
      />

      <v-video-upload
        label="视频文件"
        prefix="course-introduction"
        prop-name="raw_src"
        v-model="courseVideo.raw_src"
        :src="courseVideo.src"
        @srcChange="src => courseVideo.src = src"
      />

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">立即添加</el-button>
        <el-button @click="RouteConfig.courseVideoList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { store } from '@/api/course-video';

export default {
  name: RouteConfig.courseVideoAdd.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    courseVideo: {
      course_video_name: '',
      cover: '',
      raw_src: '',
      src: '',
      state: 1,
    },
    rules: {
      course_video_name: [{ required: true, message: '请输入封面名称', trigger: 'change' }],
      cover: [{ required: true, message: '请上传视频封面', trigger: 'change' }],
      raw_src: [{ required: true, message: '请上传视频文件', trigger: 'change' }],
    },
  }),
  methods: {
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isSaving = true;
        const postData = { ...this.courseVideo };
        const { isError } = await store(postData);
        this.isSaving = false;
        if (!isError) RouteConfig.courseVideoList.push();
      });
    },
  },
};
</script>
